import { render, staticRenderFns } from "./fileHistoryDialog.vue?vue&type=template&id=5a62c20e&"
import script from "./fileHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./fileHistoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a62c20e')) {
      api.createRecord('5a62c20e', component.options)
    } else {
      api.reload('5a62c20e', component.options)
    }
    module.hot.accept("./fileHistoryDialog.vue?vue&type=template&id=5a62c20e&", function () {
      api.rerender('5a62c20e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/ouJian/fileHistoryDialog.vue"
export default component.exports